module.exports = __webpack_public_path__ + "images/landing/video-previews/like_croissants_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/like_croissants_2x.jpg
// module id = IzYH
// module chunks = 1